import { IconName } from "@cocalc/frontend/components";

// this is imported from nextjs and frontend. keep it clean.
export const SOFTWARE_ENVIRONMENT_ICON: IconName = "hdd";
